import Grid from '@mui/material/Grid'
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { Button } from '../../features/section-components/Button'
import { SectionHeader } from '../../features/section-components/SectionHeader'
import styles from './EditName.module.scss'
import { LoadingIcon } from '../../features/section-components/LoadingIcon'
import { TextboxDesktop } from '../../features/section-components/Textbox'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import JNJFooter from '../../features/jnj-footer/JNJFooter'

const hasWindow = typeof window !== 'undefined'

const HTMLElementType = hasWindow && window.HTMLElement
  ? window.HTMLElement
  : function HTMLElement() { }

const HTMLInputElementType = hasWindow && window.HTMLInputElement
  ? window.HTMLInputElement
  : HTMLElementType

function EditNameDesktop({
  t,
  userCallStatus,
  values,
  errors,
  handleChange,
  handleSubmit,
  onCancel,
  isSaving,
  isDisabled,
  getSupportText,
  firstNameRef
}) {
  const loading = userCallStatus === 'loading'
  const firstNameTextKey = getSupportText(errors.firstName, values.firstName, 'first-name')
  const lastNameTextKey = getSupportText(errors.lastName, values.lastName, 'last-name')

  return (
    <MarginWrapper>
      <LoadingIcon isLoading={loading}>
        <div className={styles['edit-name-post-header']} />
        <div className={styles['edit-name-container']}>
          <div className={styles['back-home-section']}>
            <Link
              to="/account"
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
              color="black"
            >
              <ArrowBackIosIcon
                className={styles['home-icon']}
                fontSize="inherit"
              />
              <div className={styles['home-text']}>{t('account-tab')}</div>
            </Link>
          </div>
          <SectionHeader text={t('label-name')} size="medium" />
          <span className={styles['form-secondary-text']}>
            {t('support-text-name')}
          </span>

          <div className={styles['form-field']}>
            <span className={styles['form-label']}>
              {t('label-first-name')}
            </span>
            <TextboxDesktop
              inputRef={firstNameRef}
              name="firstName"
              value={values.firstName}
              onChange={(e) => {
                handleChange({
                  target: {
                    name: 'firstName',
                    value: e.target.value
                  }
                })
              }}
              error={!!errors.firstName}
              supportText={firstNameTextKey ? t(firstNameTextKey) : ''}
              required
            />
          </div>

          <div className={styles['form-field']}>
            <span className={styles['form-label']}>
              {t('label-last-name-optional')}
            </span>
            <TextboxDesktop
              name="lastName"
              value={values.lastName}
              onChange={(e) => {
                handleChange({
                  target: {
                    name: 'lastName',
                    value: e.target.value
                  }
                })
              }}
              error={!!errors.lastName}
              supportText={lastNameTextKey ? t(lastNameTextKey) : ''}
            />
          </div>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={10}
            xl={10}
            className={styles['edit-name-buttons']}
          >
            <Button
              text={isSaving ? '' : t('button-save-changes')}
              onClick={handleSubmit}
              buttonStyle="cta-red-oval"
              disabled={isDisabled || isSaving || values.firstName.trim().length === 0
|| (errors?.firstName || errors?.lastName)}
              icon={isSaving ? <LoadingIcon isLoading size="small" /> : null}
            />
            <Link to="/account" styles={{ textDecoration: 'none' }}>
              <Button
                text={t('button-cancel')}
                buttonStyle="filled-grey-oval"
                onClick={onCancel}
              />
            </Link>
          </Grid>
        </div>

        <div className={styles['JNJ-footer']}>
          <JNJFooter />
        </div>
      </LoadingIcon>
    </MarginWrapper>
  )
}

EditNameDesktop.propTypes = {
  t: PropTypes.func.isRequired,
  userCallStatus: PropTypes.string.isRequired,
  values: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    firstName: PropTypes.bool,
    lastName: PropTypes.bool,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  getSupportText: PropTypes.func.isRequired,
  firstNameRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.oneOfType([
        PropTypes.instanceOf(HTMLInputElementType),
        PropTypes.oneOf([null]),
      ]),
    }),
  ]).isRequired,
}

export default EditNameDesktop
